import React, { useState } from 'react';
import { Header, Segment, Button, Divider, List, Icon, Modal, Dropdown, Card } from 'semantic-ui-react';
import WebToLead from './WebToLead';

const ServicesCalculator = () => {
  const [selectedServices, setSelectedServices] = useState([]);
  const [servicesModalOpen, setServicesModalOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState('');

  const services = [
    {
      id: 'quickStart',
      name: 'Salesforce Quick Start (Basic Setup)',
      description: 'Basic Salesforce setup and configuration',
      price: 4800,
      hours: 60,
      industryAvgLow: 10000,
      industryAvgHigh: 50000,
      note: 'Price range: $4,800–$8,000 (60–100 hrs)'
    },
    {
      id: 'fullImplementation',
      name: 'Full Implementation',
      description: 'Custom objects, security, reports, and complete setup',
      price: 9600,
      hours: 120,
      industryAvgLow: 30000,
      industryAvgHigh: 150000,
      note: 'Price range: $9,600–$16,000 (120–200 hrs)'
    },
    {
      id: 'customComponents',
      name: 'Custom Components/Flows',
      description: 'Custom Lightning components and automated flows',
      price: 3200,
      hours: 40,
      industryAvgLow: 10000,
      industryAvgHigh: 50000,
      note: 'Price range: $3,200–$6,400 (40–80 hrs)'
    },
    {
      id: 'aiAutomation',
      name: 'Agentforce/AI Automation',
      description: 'AI-powered automation and intelligent features',
      price: 3200,
      hours: 40,
      industryAvgLow: 5000,
      industryAvgHigh: 25000,
      note: 'Price range: $3,200–$5,600 (40–70 hrs)'
    },
    {
      id: 'pardotSetup',
      name: 'Pardot/Account Engagement Setup + Campaigns',
      description: 'Marketing automation setup and campaign management',
      price: 5600,
      hours: 70,
      industryAvgLow: 5000,
      industryAvgHigh: 15000,
      note: 'Price range: $5,600–$9,600 (70–120 hrs)'
    },
    {
      id: 'apiIntegration',
      name: 'Single API/Third-Party Integration',
      description: 'Integration with external systems and APIs',
      price: 4000,
      hours: 50,
      industryAvgLow: 5000,
      industryAvgHigh: 20000,
      note: 'Price range: $4,000–$7,200 (50–90 hrs)'
    },
    {
      id: 'securityCompliance',
      name: 'Security/Encryption + Compliance',
      description: 'Security setup and compliance configuration',
      price: 3200,
      hours: 40,
      industryAvgLow: 5000,
      industryAvgHigh: 20000,
      note: 'Price range: $3,200–$5,600 (40–70 hrs)'
    },
    {
      id: 'dataMigration',
      name: 'Data Migration/Cleanup',
      description: 'Data import, cleanup, and migration services',
      price: 2400,
      hours: 30,
      industryAvgLow: 5000,
      industryAvgHigh: 20000,
      note: 'Price range: $2,400–$4,000 (30–50 hrs)'
    },
    {
      id: 'monthlyRetainer',
      name: 'Monthly Retainer (Up to 20 hrs/mo)',
      description: 'Ongoing support and maintenance',
      price: 1600,
      isMonthly: true,
      industryAvgLow: 2000,
      industryAvgHigh: 5000,
      isMonthlyAvg: true,
      note: 'Price range: $1,600–$3,200/mo (15–30 hrs/mo)'
    },
    {
      id: 'training',
      name: 'Training + Documentation',
      description: 'User training and comprehensive documentation',
      price: 1600,
      hours: 20,
      industryAvgLow: 2000,
      industryAvgHigh: 10000,
      note: 'Price range: $1,600–$2,800 (20–35 hrs)'
    }
  ];

  const handleAddService = () => {
    if (selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId)) {
      const serviceToAdd = services.find(s => s.id === selectedServiceId);
      if (serviceToAdd) {
        setSelectedServices(prev => [...prev, serviceToAdd]);
        setSelectedServiceId(''); // Clear selection after adding
      }
    }
  };

  const handleRemoveService = (serviceId) => {
    setSelectedServices(prev => prev.filter(s => s.id !== serviceId));
  };

  const calculateTotal = () => {
    let total = 0;
    let totalHours = 0;

    selectedServices.forEach(service => {
      total += service.price;
      if (service.hours) {
        totalHours += service.hours;
      }
    });

    return { total, totalHours };
  };

  const handleServicesModalOpen = () => {
    setServicesModalOpen(true);
  };

  const handleServicesModalClose = () => {
    setServicesModalOpen(false);
  };

  const { total, totalHours } = calculateTotal();
  const selectedCount = selectedServices.length;

  const dropdownOptions = services.map(service => ({
    key: service.id,
    text: service.name,
    value: service.id
  }));

  const selectedService = services.find(s => s.id === selectedServiceId);
  const isMobile = window.innerWidth < 768;

  return (
    <div style={{ marginTop: '1em', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto', backgroundColor: 'white', padding: isMobile ? '1.5em 1em' : '2em', borderRadius: '8px', width: isMobile ? '100%' : 'auto', boxSizing: 'border-box', border: '2px solid #a9885c' }}>
      <Header as='h2' style={{ color: '#702963', textAlign: 'center', marginBottom: '1em' }}>
        <Icon name='calculator' />
        Services Calculator
      </Header>

        <Header as='h3' style={{ color: '#702963', textAlign: 'center', marginBottom: '0.5em' }}>
            <Icon name='lightbulb' />
            How It Works
          </Header>
          <p style={{ color: '#a9885c', textAlign: 'center', marginBottom: '1em', fontSize: '1.2em', fontWeight: 'bold' }}>
            Select the services you're interested in to get an instant quote estimate
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1em', flexWrap: 'wrap', flexDirection: window.innerWidth < 1024 ? 'column' : 'row' }}>
            <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
              <Icon name='dollar sign' size='large' style={{ color: '#a9885c', marginBottom: '0.5em' }} />
              <div style={{ color: '#702963', fontSize: '0.9em', fontWeight: 'bold' }}>All Prices in USD</div>
              <div style={{ color: '#a9885c', fontSize: '0.8em' }}>Transparent pricing</div>
            </div>
            <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
              <Icon name='chart bar' size='large' style={{ color: '#a9885c', marginBottom: '0.5em' }} />
              <div style={{ color: '#702963', fontSize: '0.9em', fontWeight: 'bold' }}>Industry Comparison</div>
              <div style={{ color: '#a9885c', fontSize: '0.8em' }}>See how you compare</div>
            </div>
            <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
              <Icon name='clock' size='large' style={{ color: '#a9885c', marginBottom: '0.5em' }} />
              <div style={{ color: '#702963', fontSize: '0.9em', fontWeight: 'bold' }}>Typical Project Scopes</div>
              <div style={{ color: '#a9885c', fontSize: '0.8em' }}>Based on real projects</div>
            </div>
          </div>

          <Divider style={{ margin: '2em 0 1.5em 0' }} />

          <Header as='h3' style={{ color: '#702963', textAlign: 'center', marginBottom: '1em' }}>
            Add Services to Quote
          </Header>

          <div style={{ display: isMobile ? 'block' : 'flex', flexDirection: 'row', gap: '1em', marginBottom: '1.5em' }}>
            {!isMobile && (
              <Button 
                secondary 
                onClick={handleServicesModalOpen}
                style={{ backgroundColor: '#f9f9f9', color: '#702963', border: '1px solid #a9885c', whiteSpace: 'nowrap', width: 'auto' }}
              >
                <Icon name='list' />
                View All Services
              </Button>
            )}

            {!isMobile && (
              <div style={{ flex: 1 }}>
                <Dropdown
                  placeholder='Select a service...'
                  fluid
                  selection
                  options={dropdownOptions}
                  value={selectedServiceId}
                  onChange={(e, { value }) => setSelectedServiceId(value)}
                  style={{ marginBottom: '1em' }}
                />
                
                {selectedService && (
                  <Card fluid style={{ backgroundColor: '#f9f9f9', border: '1px solid #a9885c' }}>
                    <Card.Content>
                      <Card.Header style={{ color: '#702963', fontSize: '1.2em' }}>
                        {selectedService.name}
                      </Card.Header>
                      <Card.Description style={{ color: '#a9885c', margin: '0.5em 0' }}>
                        {selectedService.description}
                      </Card.Description>
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: '1em' }}>
                        <div>
                          <strong style={{ color: '#702963', fontSize: '1.3em' }}>
                            {selectedService.isMonthly ? `$${selectedService.price}/mo` : `$${selectedService.price.toLocaleString()}`}
                          </strong>
                          {selectedService.hours && (
                            <div style={{ color: '#a9885c', fontSize: '0.9em', marginTop: '0.2em' }}>
                              ({selectedService.hours} hours)
                            </div>
                          )}
                        </div>
                        {selectedService.note && (
                          <div style={{ color: '#702963', fontSize: '0.85em', fontStyle: 'italic', maxWidth: '200px' }}>
                            {selectedService.note}
                          </div>
                        )}
                      </div>
                    </Card.Content>
                  </Card>
                )}
              </div>
            )}

            {!isMobile && (
              <Button
                primary
                size='large'
                onClick={() => {
                  if (selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId)) {
                    handleAddService();
                  }
                }}
                disabled={false}
                style={{ 
                  backgroundColor: selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId) ? '#702963' : '#ccc',
                  borderColor: selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId) ? '#702963' : '#ccc',
                  minWidth: '60px',
                  height: '40px',
                  cursor: selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId) ? 'pointer' : 'not-allowed',
                  opacity: selectedServiceId && !selectedServices.find(s => s.id === selectedServiceId) ? 1 : 0.6
                }}
              >
                <Icon name='plus' />
              </Button>
            )}
          </div>

          {isMobile && (
            <Button
              secondary
              onClick={handleServicesModalOpen}
              style={{ backgroundColor: '#702963', color: '#a9885c', border: '1px solid #a9885c', width: '100%', marginBottom: '1em' }}
            >
              <Icon name='list' />
              Select Services to Quote
            </Button>
          )}

        <Divider />

        <div style={{ backgroundColor: 'white', padding: isMobile ? '1.5em 1em' : '2em', borderRadius: '12px', margin: '1em 0', border: '2px solid #a9885c', boxSizing: 'border-box' }}>
          <Header as='h3' style={{ color: '#702963', textAlign: 'center', marginBottom: '1.5em', fontSize: '1.5em' }}>
            <Icon name='calculator' />
            Your Quote Summary
          </Header>

          {selectedCount === 0 ? (
            <div style={{ textAlign: 'center', padding: '2em' }}>
              <Icon name='arrow up' size='huge' style={{ color: '#a9885c', marginBottom: '1em' }} />
              <p style={{ color: '#a9885c', fontSize: '1.2em', fontWeight: 'bold' }}>
                Select services above to see your quote
              </p>
            </div>
          ) : (
            <div>
              <div style={{ textAlign: 'center', marginBottom: '2em' }}>
                <div style={{ 
                  backgroundColor: '#a9885c', 
                  color: '#702963', 
                  padding: '0.5em 1em', 
                  borderRadius: '20px', 
                  display: 'inline-block',
                  fontSize: '1.1em',
                  fontWeight: 'bold'
                }}>
                  {selectedCount} Service{selectedCount !== 1 ? 's' : ''} Selected
                </div>
              </div>

              {/* Service Breakdown */}
              <div style={{ marginBottom: '2em' }}>
                <Header as='h3' style={{ color: '#702963', textAlign: 'center', marginBottom: '1em' }}>
                  <Icon name='chart bar' />
                  Service Breakdown & Industry Comparison
                </Header>
                <List divided relaxed style={{ backgroundColor: '#f9f9fa', borderRadius: '8px', padding: isMobile ? '0.75em' : '1em' }}>
                  {selectedServices.map((service, index) => {
                    const industryAvg = {
                      low: service.industryAvgLow,
                      high: service.industryAvgHigh,
                      average: Math.round((service.industryAvgLow + service.industryAvgHigh) / 2),
                      isMonthly: service.isMonthlyAvg || false
                    };

                    const getComparisonText = (proposed, avg) => {
                      const ratio = proposed / avg.average;
                      if (ratio < 0.8) return { text: 'Significantly Lower', color: '#4CAF50', icon: 'arrow down' };
                      if (ratio < 0.95) return { text: 'Lower', color: '#8BC34A', icon: 'arrow down' };
                      if (ratio <= 1.05) return { text: 'In Line', color: '#FFC107', icon: 'minus' };
                      if (ratio <= 1.2) return { text: 'Higher', color: '#FF9800', icon: 'arrow up' };
                      return { text: 'Significantly Higher', color: '#F44336', icon: 'arrow up' };
                    };

                    const comparison = getComparisonText(service.price, industryAvg);

                    return (
                      <List.Item key={service.id} style={{ padding: '1em 0' }}>
                        <List.Content>
                          <div style={{ marginBottom: '0.5em' }}>
                            <div style={{ color: '#a9885c', fontSize: '1.1em', fontWeight: 'bold' }}>
                              {service.name}
                            </div>
                            {service.hours && (
                              <div style={{ color: 'rgba(168, 136, 92, 0.8)', fontSize: '0.9em' }}>
                                ({service.hours} hrs)
                              </div>
                            )}
                          </div>
                          
                          <div style={{ display: 'flex', flexDirection: window.innerWidth < 1024 ? 'column' : 'row', justifyContent: window.innerWidth < 1024 ? 'flex-start' : 'space-between', alignItems: window.innerWidth < 1024 ? 'flex-start' : 'center', gap: '1em' }}>
                            <div style={{ flex: 1, textAlign: window.innerWidth < 1024 ? 'left' : 'left' }}>
                              <div style={{ color: '#a9885c', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '0.2em' }}>
                                Your Quote:
                              </div>
                              <div style={{ color: '#a9885c', fontSize: '1.3em', fontWeight: 'bold' }}>
                                ${service.price.toLocaleString()}
                                {service.isMonthly && '/mo'}
                              </div>
                            </div>
                            
                            <div style={{ flex: 1, textAlign: window.innerWidth < 1024 ? 'left' : 'center' }}>
                              <div style={{ color: 'rgba(168, 136, 92, 0.7)', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '0.2em' }}>
                                Industry Average:
                              </div>
                              <div style={{ color: 'rgba(168, 136, 92, 0.9)', fontSize: '1.1em' }}>
                                ${industryAvg.low.toLocaleString()}–${industryAvg.high.toLocaleString()}{industryAvg.isMonthly && '/mo'}
                              </div>
                              <div style={{ color: 'rgba(168, 136, 92, 0.6)', fontSize: '0.8em', marginTop: '0.2em' }}>
                                (Avg: ${industryAvg.average.toLocaleString()}{industryAvg.isMonthly && '/mo'})
                              </div>
                            </div>

                            <div style={{ flex: 1, textAlign: window.innerWidth < 1024 ? 'left' : 'right' }}>
                              <div style={{ color: 'rgba(168, 136, 92, 0.7)', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '0.2em' }}>
                                Comparison:
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: window.innerWidth < 1024 ? 'flex-start' : 'flex-end', gap: '0.3em' }}>
                                <Icon name={comparison.icon} style={{ color: comparison.color }} />
                                <span style={{ color: comparison.color, fontSize: '1em', fontWeight: 'bold' }}>
                                  {comparison.text}
                                </span>
                              </div>
                              <div style={{ color: 'rgba(168, 136, 92, 0.6)', fontSize: '0.8em', marginTop: '0.2em' }}>
                                {((service.price / industryAvg.average) * 100).toFixed(0)}% of avg
                              </div>
                            </div>
                          </div>
                          <div style={{ textAlign: 'right', marginTop: '0.5em' }}>
                            <Button
                              icon
                              size='small'
                              onClick={() => handleRemoveService(service.id)}
                              style={{ backgroundColor: '#a9885c', color: '#702963' }}
                            >
                              <Icon name='trash' />
                            </Button>
                          </div>
                        </List.Content>
                      </List.Item>
                    );
                  })}
                </List>
              </div>

              {/* Overall Comparison Summary */}
              {(() => {
                const totalIndustryAvg = selectedServices.reduce((sum, service) => {
                  const avg = Math.round((service.industryAvgLow + service.industryAvgHigh) / 2);
                  return sum + avg;
                }, 0);

                const savings = totalIndustryAvg - total;
                const savingsPercentage = totalIndustryAvg > 0 ? ((savings / totalIndustryAvg) * 100).toFixed(0) : 0;

                return (
                  <div style={{ marginBottom: '2em', textAlign: 'center' }}>
                    <div style={{ 
                      backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                      padding: '1.5em', 
                      borderRadius: '12px',
                      border: '2px solid #a9885c'
                    }}>
                      <Header as='h4' style={{ color: '#702963', marginBottom: '1em' }}>
                        <Icon name='chart line' />
                        Overall Value Comparison
                      </Header>
                      
                      <div style={{ display: 'flex', flexDirection: window.innerWidth < 1024 ? 'column' : 'row', justifyContent: 'center', gap: window.innerWidth < 1024 ? '1em' : '2em', alignItems: 'center', flexWrap: 'wrap', marginBottom: '1em' }}>
                        <div>
                          <div style={{ color: 'rgba(168, 136, 92, 0.8)', fontSize: '0.9em', fontWeight: 'bold' }}>
                            Industry Average Total:
                          </div>
                          <div style={{ color: 'rgba(168, 136, 92, 0.9)', fontSize: '1.4em', fontWeight: 'bold' }}>
                            ${totalIndustryAvg.toLocaleString()}
                            {selectedServices.some(s => s.isMonthly) && '/mo'}
                          </div>
                        </div>
                        
                        <div>
                          <div style={{ color: '#a9885c', fontSize: '0.9em', fontWeight: 'bold' }}>
                            Your Total:
                          </div>
                          <div style={{ color: '#a9885c', fontSize: '1.4em', fontWeight: 'bold' }}>
                            ${total.toLocaleString()}
                            {selectedServices.some(s => s.isMonthly) && '/mo'}
                          </div>
                        </div>
                        
                        {savings > 0 && (
                          <div>
                            <div style={{ color: '#4CAF50', fontSize: '0.9em', fontWeight: 'bold' }}>
                              Potential Savings:
                            </div>
                            <div style={{ color: '#4CAF50', fontSize: '1.4em', fontWeight: 'bold' }}>
                              ${savings.toLocaleString()} ({savingsPercentage}%)
                            </div>
                          </div>
                        )}
                      </div>
                      
                      <div style={{ 
                        backgroundColor: 'rgba(76, 175, 80, 0.1)', 
                        padding: '1em', 
                        borderRadius: '8px',
                        border: '1px solid #4CAF50'
                      }}>
                        <p style={{ color: '#4CAF50', fontSize: '0.95em', margin: 0, fontWeight: 'bold' }}>
                          <Icon name='check circle' />
                          Your estimates align well or come in lower than typical industry ranges, providing excellent value for budget-conscious businesses.
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Total Section */}
              <div style={{ 
                display: 'flex', 
                flexDirection: window.innerWidth < 1024 ? 'column' : 'row',
                justifyContent: 'center', 
                gap: window.innerWidth < 1024 ? '1.5em' : '3em', 
                marginBottom: '2em',
                alignItems: 'center'
              }}>
                {totalHours > 0 && (
                  <div style={{ 
                    backgroundColor: 'rgba(168, 133, 92, 0.1)', 
                    padding: '1.5em', 
                    borderRadius: '12px',
                    border: '2px solid #a9885c',
                    minWidth: '200px',
                    textAlign: 'center'
                  }}>
                    <Icon name='clock' size='large' style={{ color: '#a9885c', marginBottom: '0.5em' }} />
                    <div style={{ color: '#a9885c', fontSize: '0.9em', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
                      Total Hours
                    </div>
                    <div style={{ color: '#a9885c', fontSize: '2.5em', fontWeight: 'bold', marginTop: '0.3em' }}>
                      {totalHours}
                    </div>
                  </div>
                )}
                
                <div style={{ 
                  backgroundColor: 'rgba(168, 133, 92, 0.1)', 
                  padding: '1.5em', 
                  borderRadius: '12px',
                  border: '2px solid #a9885c',
                  minWidth: '200px',
                  textAlign: 'center'
                }}>
                  <Icon name='dollar' size='large' style={{ color: '#a9885c', marginBottom: '0.5em' }} />
                  <div style={{ color: '#a9885c', fontSize: '0.9em', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
                    {(() => {
                      const hasMonthlyService = selectedServices.some(s => s.isMonthly);
                      return hasMonthlyService ? 'Monthly Total' : 'Total Estimate';
                    })()}
                  </div>
                  <div style={{ color: '#a9885c', fontSize: '2.5em', fontWeight: 'bold', marginTop: '0.3em' }}>
                    ${total.toLocaleString()}
                    {(() => {
                      const hasMonthlyService = selectedServices.some(s => s.isMonthly);
                      return hasMonthlyService ? '/mo' : '';
                    })()}
                  </div>
                </div>
              </div>

              <div style={{ textAlign: 'center', marginBottom: '2em' }}>
                <div style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.9)', 
                  padding: '1em', 
                  borderRadius: '8px',
                  display: 'inline-block',
                  maxWidth: '500px'
                }}>
                  <p style={{ color: '#702963', fontSize: '0.9em', margin: 0, fontStyle: 'italic' }}>
                    <Icon name='info circle' style={{ marginRight: '0.5em' }} />
                    This is an estimate based on typical project scopes. Final pricing may vary based on specific requirements.
                  </p>
                </div>
              </div>

              <div style={{ textAlign: 'center' }}>
                <Button
                  primary
                  size='huge'
                  style={{ 
                    backgroundColor: '#a9885c', 
                    borderColor: '#a9885c',
                    color: '#702963',
                    padding: '1em 2em',
                    fontSize: '1.2em',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => setContactModalOpen(true)}
                >
                  <Icon name='envelope' />
                  Get Detailed Quote
                </Button>
              </div>
            </div>
          )}
        </div>

      {/* Contact Modal */}
      <Modal 
        open={contactModalOpen} 
        onClose={() => setContactModalOpen(false)} 
        size='large'
        style={{ backgroundColor: 'white' }}
      >
        <Modal.Header style={{ backgroundColor: '#702963', color: '#a9885c', textAlign: 'center' }}>
          <Icon name='envelope' />
          Contact Us
        </Modal.Header>
        <Modal.Content style={{ backgroundColor: 'white' }}>
          <WebToLead />
        </Modal.Content>
      </Modal>

      {/* Services Modal */}
      <Modal 
        open={servicesModalOpen} 
        onClose={handleServicesModalClose} 
        size='large'
        style={{ backgroundColor: 'white' }}
      >
        <Modal.Header style={{ backgroundColor: '#702963', color: '#a9885c', textAlign: 'center' }}>
          <Icon name='cogs' />
          All Available Services
        </Modal.Header>
        <Modal.Content style={{ backgroundColor: 'white' }}>
          <p style={{ color: '#a9885c', textAlign: 'center', marginBottom: '2em', fontSize: '1.1em' }}>
            {isMobile ? 'Click services to select them for your quote' : 'Comprehensive list of all services offered. All prices are estimates based on typical project scopes.'}
          </p>
          
          <List divided relaxed>
            {services.map(service => {
              const isSelected = selectedServices.find(s => s.id === service.id);
              return (
                <List.Item 
                  key={service.id} 
                  style={{ 
                    padding: '1.5em', 
                    backgroundColor: isSelected ? 'rgba(112, 41, 99, 0.1)' : 'transparent',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    border: isSelected ? '2px solid #702963' : 'none',
                    margin: '0.5em 0'
                  }}
                  onClick={() => {
                    if (isSelected) {
                      handleRemoveService(service.id);
                    } else {
                      setSelectedServices(prev => [...prev, service]);
                    }
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', flex: 1 }}>
                      <input
                        type='checkbox'
                        checked={isSelected}
                        onChange={() => {}}
                        style={{ marginRight: '1em', marginTop: '0.3em', cursor: 'pointer', width: '20px', height: '20px' }}
                      />
                      <div style={{ flex: 1 }}>
                        <strong style={{ color: '#702963', fontSize: '1.2em', display: 'block', marginBottom: '0.5em' }}>
                          {service.name}
                        </strong>
                        <p style={{ color: '#a9885c', margin: '0.5em 0', lineHeight: '1.6' }}>
                          {service.description}
                        </p>
                        {service.note && (
                          <p style={{ color: '#702963', margin: '0.3em 0', fontSize: '0.9em', fontStyle: 'italic' }}>
                            {service.note}
                          </p>
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', marginLeft: '2em', minWidth: '120px' }}>
                      <div style={{ color: '#702963', fontSize: '1.4em', fontWeight: 'bold' }}>
                        {service.isMonthly ? `$${service.price}/mo` : `$${service.price.toLocaleString()}`}
                      </div>
                      {service.hours && (
                        <div style={{ color: '#a9885c', fontSize: '0.9em', marginTop: '0.3em' }}>
                          ({service.hours} hours)
                        </div>
                      )}
                    </div>
                  </div>
                </List.Item>
              );
            })}
          </List>
        </Modal.Content>
        <Modal.Actions style={{ backgroundColor: '#f9f9f9', textAlign: 'center' }}>
          <Button 
            onClick={handleServicesModalClose}
            style={{ backgroundColor: '#702963', color: '#a9885c' }}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>

    </div>
  );
};

export default ServicesCalculator;